import { buildDashboardUrl, type DashboardRoute } from "./dashboardRoutes";

const listScrollByUrl = new Map<string, number>();
const detailScrollByUrl = new Map<string, number>();

export function dashboardScrollKey(route: DashboardRoute): string {
  return buildDashboardUrl(route);
}

export function getDashboardListScrollContainer(): HTMLElement | null {
  return document.querySelector(".dashboard-views-wrap");
}

export function getClientDetailScrollContainer(): HTMLElement | null {
  return document.querySelector(".client-detail-panel-scroll");
}

export function saveScrollForRoute(route: DashboardRoute): void {
  const key = dashboardScrollKey(route);
  const list = getDashboardListScrollContainer();
  if (list) listScrollByUrl.set(key, list.scrollTop);
  const detail = getClientDetailScrollContainer();
  if (detail) detailScrollByUrl.set(key, detail.scrollTop);
}

export function restoreScrollForRoute(route: DashboardRoute): void {
  const key = dashboardScrollKey(route);
  const listY = listScrollByUrl.get(key);
  const detailY = detailScrollByUrl.get(key);

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      const list = getDashboardListScrollContainer();
      if (list && listY != null) list.scrollTop = listY;

      const detail = getClientDetailScrollContainer();
      if (detail && detailY != null) detail.scrollTop = detailY;
    });
  });
}

export type ScrollToTopOptions = {
  /** Only reset the client detail panel scroll (keep list position). */
  detailOnly?: boolean;
};

export function scrollDashboardToTop(options?: ScrollToTopOptions): void {
  if (!options?.detailOnly) {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    const list = getDashboardListScrollContainer();
    if (list) list.scrollTop = 0;
  }

  const detail = getClientDetailScrollContainer();
  if (detail) detail.scrollTop = 0;
}

export function applyDashboardScrollAfterNavigation(
  route: DashboardRoute,
  mode: "top" | "restore",
): void {
  if (mode === "restore") {
    restoreScrollForRoute(route);
    return;
  }

  if (route.clientId) {
    scrollDashboardToTop({ detailOnly: true });
  } else {
    scrollDashboardToTop();
  }
}

export function disableBrowserScrollRestoration(): void {
  if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual";
  }
}
